import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoComparacao() {
  return (
    <ArtigoPlaceholder
      title="CSSBuy vs Outros Agentes de Compra: Qual o Melhor para Você?"
      desc="Comparação detalhada entre CSSBuy, Wegobuy, Pandabuy e outros agentes. Preços, taxas, velocidade de envio e qualidade do serviço comparados."
      icon="ri-scales-line"
      slug="artigo-cssbuy-comparacao"
    />
  );
}